import React from 'react';
import { Circle, Group } from 'react-konva';

/**
 * LineHandles Component
 * Shows draggable circular handles at line endpoints when selected
 * Allows users to resize/reshape lines by dragging endpoints
 */
function LineHandles({ line, isSelected, onUpdate }) {
  // Only show handles for selected lines
  if (!isSelected || line.type !== 'line') return null;

  const points = line.points || [0, 0, 100, 0];
  
  // Extract endpoint coordinates
  // Points array format: [x1, y1, x2, y2, ...]
  const x1 = (line.x || 0) + points[0];
  const y1 = (line.y || 0) + points[1];
  const x2 = (line.x || 0) + points[2];
  const y2 = (line.y || 0) + points[3];

  // Handle dragging of start point - only update Firestore on drag end
  const handleStartDragEnd = (e) => {
    const node = e.target;
    const newX = node.x();
    const newY = node.y();
    
    // Update the first point coordinates
    const newPoints = [...points];
    newPoints[0] = newX - (line.x || 0);
    newPoints[1] = newY - (line.y || 0);
    
    // Update Firestore only on drag end
    onUpdate(line.id, { points: newPoints });
  };

  // Handle dragging of end point - only update Firestore on drag end
  const handleEndDragEnd = (e) => {
    const node = e.target;
    const newX = node.x();
    const newY = node.y();
    
    // Update the second point coordinates
    const newPoints = [...points];
    newPoints[2] = newX - (line.x || 0);
    newPoints[3] = newY - (line.y || 0);
    
    // Update Firestore only on drag end
    onUpdate(line.id, { points: newPoints });
  };

  // Prevent handle clicks from propagating to line
  const handleClick = (e) => {
    e.cancelBubble = true;
  };

  return (
    <Group>
      {/* Start point handle */}
      <Circle
        x={x1}
        y={y1}
        radius={8}
        fill="#3b82f6"
        stroke="#ffffff"
        strokeWidth={2}
        draggable={true}
        onDragEnd={handleStartDragEnd}
        onClick={handleClick}
        onTap={handleClick}
        shadowColor="#000000"
        shadowBlur={4}
        shadowOpacity={0.3}
        shadowOffset={{ x: 0, y: 2 }}
        onMouseEnter={(e) => {
          const stage = e.target.getStage();
          if (stage) stage.container().style.cursor = 'move';
        }}
        onMouseLeave={(e) => {
          const stage = e.target.getStage();
          if (stage) stage.container().style.cursor = 'default';
        }}
      />
      
      {/* End point handle */}
      <Circle
        x={x2}
        y={y2}
        radius={8}
        fill="#3b82f6"
        stroke="#ffffff"
        strokeWidth={2}
        draggable={true}
        onDragEnd={handleEndDragEnd}
        onClick={handleClick}
        onTap={handleClick}
        shadowColor="#000000"
        shadowBlur={4}
        shadowOpacity={0.3}
        shadowOffset={{ x: 0, y: 2 }}
        onMouseEnter={(e) => {
          const stage = e.target.getStage();
          if (stage) stage.container().style.cursor = 'move';
        }}
        onMouseLeave={(e) => {
          const stage = e.target.getStage();
          if (stage) stage.container().style.cursor = 'default';
        }}
      />
    </Group>
  );
}

export default LineHandles;

